<template>
  <div v-if="isSampleProductPage" class="fixed bottom-4 right-0 z-[9999]">
    <!-- Floating Content Studio Button -->
    <div class="relative group">
      <!-- Pulsing background -->
      <div class="absolute inset-0 bg-coral-600 group-hover:bg-dark-teal-600 rounded-l-full animate-ping group-hover:animate-none opacity-40"></div>
      <!-- Main button -->
      <button
        @click="openContentStudio"
        class="uppercase relative flex items-center justify-center gap-2 bg-light-pink-200 group-hover:bg-dark-teal-600 group-hover:text-light-pink-200 text-white p-4 rounded-l-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 group shadow-md shadow-gray-600 border-dark-teal-600 py-3 border border-l-2 border-y-2 border-dark-teal-600"
        :title="t('contentStudioFloatingButton.tooltip')"
      >
      <span class="pr-16 font-medium tracking-widest mr-4 text-dark-teal-600 group-hover:text-light-pink-200 whitespace-nowrap">
        <span class="p-2 bg-dark-teal-600 text-light-pink-200 rounded-full mr-2">⚠️</span> 
        {{ t('contentStudioFloatingButton.sampleLabel') }}
      </span>
      <!-- <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="md:size-12 size-8 bg-red-600 rounded-full p-2 border border-dark-teal-600">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
      </svg> -->
      </button>
    </div>
    
    <!-- Content Studio Modal -->
    <ContentStudio ref="contentStudio" />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRoute, useI18n } from '#imports'
import ContentStudio from './ContentStudio.vue'

const route = useRoute()
const contentStudio = ref(null)
const { t } = useI18n()

// Check if current route is the sample product page
const isSampleProductPage = computed(() => {
  const name = route.name ? route.name.toString() : ''
  const path = route.path || ''
  return path.includes('/sample-product-page') || name.includes('sample-product-page')
})

const openContentStudio = () => {
  if (contentStudio.value) {
    contentStudio.value.openModal()
  }
}
</script>
